import React from 'react';

export default function RangeList({className, id, value, options, onChange, emptyValueLabel, isLoading, formatType, bounds}) {
    const getValue = (option) => {
        let value = option;

        switch (formatType) {
            case 'price':
                value = option.toLocaleString('nl-NL', {
                    style: 'currency',
                    currency: 'EUR',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                });
                break;
            case 'tellerstand':
                value = new Intl.NumberFormat('nl-NL').format(option);
                break;
        }

        return value;
    };

    return (
        <select
            id={id}
            className={className}
            value={value}
            disabled={isLoading}
            onChange={({target: {value}}) => {
                onChange(value);
            }}>
            <option value={bounds} disabled>
                {emptyValueLabel}
            </option>
            {options.map((option, optionIndex) => {
                return (
                    <option value={option} key={optionIndex}>
                        {getValue(option)}
                    </option>
                );
            })}
        </select>
    );
}
